import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./popup.css";

const Popup = () => {
  const [showPopup, setShowPopup] = useState(false);

  // Auto open after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000); // 5000ms = 5 seconds

    return () => clearTimeout(timer); // cleanup
  }, []);

  if (!showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box side-popup">
        <button
          className="popup-close"
          onClick={() => setShowPopup(false)}
        >
          ×
        </button>

        <h2>Let’s Connect 🚀</h2>
        <p>
          Have a project in mind? Let’s build something amazing together.
        </p>

        <Link
          to="/contact"
          className="popup-btn"
          onClick={() => setShowPopup(false)}
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
};

export default Popup;
